import { ApolloError } from '@apollo/client';

// Business rule failures (taken hostname, one domain per partner) come back as the error message.
export function getGraphQLErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApolloError) return error.graphQLErrors[0]?.message ?? fallback;

  return fallback;
}
